















import {Vue, Component} from 'vue-property-decorator'
import {Getter, Action} from 'vuex-class'
import {unlockChatForwarding} from '@/api/chat'

@Component
export default class ChatForwardingLocked extends Vue {
    @Getter public chatCustomData
    @Action public setChatCustomData

    public get chatForwardingLocked() {
        return Number(this.chatCustomData.chat_forwarding_locked)
    }
    public async enableChatForwarding() {
        const response = await unlockChatForwarding(this.chatCustomData.id)
        if (response.data.success) {
            this.setChatCustomData({...this.chatCustomData, chat_forwarding_locked: 0})
        }
    }
}
